import { TDict } from './utilityTypes';

export type TKeystoneAffix = {
  id: number;
  icon: string;
  name: TDict<string>;
  slug: string;
  description: TDict<string>;
};

export type TFormattedAffixData = {
  id: number;
  icon: string;
  name: string;
  slug: string;
  description: string;
};

export type TClientAffixData = Omit<TKeystoneAffix, 'name' | 'description'>;

export type TKeystoneAffixSchedule = {
  ordinal: number;
  names: string[];
};

export type TKeystoneAffixData = {
  schedule: TKeystoneAffixSchedule[];
  affixes: TKeystoneAffix[];
};

export const enum Affixes {
  TEEMING = 5,
  TYRANNICAL = 9,
  FORTIFIED = 10,
  CHALLENGERS_PERIL = 152
}

export type TPickedKeystoneAffix = {
  id: number;
  icon: string;
  name: string;
};

export type TAffixScheduleEntry = {
  name: string;
  slug: string;
  affixes: TPickedKeystoneAffix[];
};

export type THeroSubTree = {
  id: number;
  name: string;
  slug: string;
};
